export default __webpack_public_path__ + "img/04ae2cf787429eae2ffa3f6bc6bcdf4a.svg";